import React, { useState } from 'react';
import styles from './Topbar.module.css';
import { IoMdLogOut } from "react-icons/io";
import { FaInfoCircle, FaWindowClose } from "react-icons/fa";
import { FiSettings } from "react-icons/fi";
import { MdAddLocationAlt, MdEditLocationAlt, MdStars } from "react-icons/md";
import { BiSolidContact } from "react-icons/bi";
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DarkMode from '../darkmode/DarkMode';
import { useTheme } from '../ThemeContext';
import SiCamProgram from './SiCamProgram.pdf';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

const Topbar = () => {
  const { theme } = useTheme();
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const [adminMenuAnchor, setAdminMenuAnchor] = useState(null);
  const navigate = useNavigate();
  const { signOut } = useAuth();

  const handleLogout = () => {
    signOut().finally(() => navigate('/login'));
  };

  const handleOpenAdminMenu = (event) => {
    setAdminMenuAnchor(event.currentTarget);
  };

  const handleCloseAdminMenu = () => {
    setAdminMenuAnchor(null);
  };

  const handleAdminAction = (action) => {
    handleCloseAdminMenu();
    navigate(`/actions?admin=${action}&t=${Date.now()}`);
  };

  return (
    <>
      <div className={`${styles.topnav} ${styles[theme]}`}>
        <h2 className={`${styles.text1} ${styles[theme]}`}>SICAM SYSTEMS</h2>
        <h3 className={`${styles.text2} ${styles[theme]}`}>TRACKING SYSTEM</h3>

        <div className={styles.group}>
          <DarkMode style={{ fontSize: '20px' }} />

          <IconButton
            className={`${styles.iconButton} ${styles[theme]}`}
            onClick={handleOpenAdminMenu}
            title="Admin Features"
          >
            <FiSettings style={{ fontSize: '24px' }} />
          </IconButton>

          <div
            className={`${styles.icon2} ${styles[theme]}`}
            onClick={() => setIsOverlayOpen(true)}
            title="View Support Pamphlet"
            style={{ cursor: 'pointer' }}
          >
            <FaInfoCircle style={{ fontSize: '25px' }} />
          </div>

          <div
            className={`${styles.icon} ${styles[theme]}`}
            onClick={handleLogout}
            title="Logout"
            style={{ cursor: 'pointer' }}
          >
            <IoMdLogOut style={{ fontSize: '25px' }} />
          </div>
        </div>
      </div>

      <Menu
        anchorEl={adminMenuAnchor}
        open={Boolean(adminMenuAnchor)}
        onClose={handleCloseAdminMenu}
        PaperProps={{
          className: `${styles.adminMenuPaper} ${styles[theme]}`,
        }}
      >
        <MenuItem onClick={() => handleAdminAction('add-location')}>
          <ListItemIcon>
            <MdAddLocationAlt />
          </ListItemIcon>
          <ListItemText>Add Location</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleAdminAction('edit-location')}>
          <ListItemIcon>
            <MdEditLocationAlt />
          </ListItemIcon>
          <ListItemText>Edit Location</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleAdminAction('support-plan')}>
          <ListItemIcon>
            <MdStars />
          </ListItemIcon>
          <ListItemText>Support Plan</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleAdminAction('contact')}>
          <ListItemIcon>
            <BiSolidContact />
          </ListItemIcon>
          <ListItemText>Contact</ListItemText>
        </MenuItem>
      </Menu>

      {isOverlayOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.85)',
            zIndex: 1000,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            padding: '30px',
          }}
        >
          <FaWindowClose
            onClick={() => setIsOverlayOpen(false)}
            style={{
              position: 'fixed',
              top: 20,
              right: 30,
              fontSize: 36,
              color: 'white',
              cursor: 'pointer',
              zIndex: 1100,
            }}
          />
          <div style={{ width: '80%', height: '90%', position: 'relative', zIndex: 1000 }}>
            <iframe
              src={`${SiCamProgram}#toolbar=0&navpanes=0&scrollbar=0`}
              title="Support Pamphlet"
              style={{
                width: '100%',
                height: '100%',
                border: 'none',
                borderRadius: '8px',
                backgroundColor: '#fff',
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Topbar;
